<template>
  <div>
    <create-dialog
      ref="CreateDialogRef"
      v-model="createShow"
      @editSubmit="onSubmit"></create-dialog>
  </div>
</template>

<script>
import { Baseurl, ajaxPost, ajaxGet } from '@/api/api/api'

import CreateDialog from './create.vue'

export default {
  components: {
    CreateDialog
  },
  data() {
    return {
      createShow: false,
      id: ''
    }
  },
  methods: {
    async fetchDetails(id) {
      try {
        this.id = id
        const url =
          Baseurl +
          `/shopeeGlobalProductInfo/getShopeeGlobalProductDetail/${id}`
        const res = await ajaxGet(url)
        const { code, data, message } = res.data
        if (code === 200) {
          this.createShow = true
          this.$nextTick(() => {
            this.$refs.CreateDialogRef.setFormData({ id, ...data, type: 'update' })
          })
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onSubmit(payload) {
      try {
        const url =
          Baseurl + `/shopeeGlobalProductInfo/updateGlobalProduct`

        const res = await ajaxPost(url, payload)
        this.$refs.CreateDialogRef.loadingStatus = false
        const { code, message } = res.data
        if (code === 200) {
          this.createShow = false
          this.$message.success('操作成功')
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        this.$refs.CreateDialogRef.loadingStatus = false
        console.log(error)
      }
    }
  }
}
</script>
